export default {
  autoReloadOffTooltip: 'Automatic reload off',
  forceRefreshTooltip: 'Refresh component data',
  autoReloadOnTooltip: 'Last update {date}',
};
